<div class="basin-pb-4 basin-width-100">
  <form [formGroup]="form" class="form-container basin-display-flex basin-gap-2">
    <formly-form [form]="form" [fields]="licenseFields" [model]="model" [options]="options"></formly-form>
  </form>
</div>

<div class="basin-display-flex basin-justify-content-end basin-width-100">
  <button pButton type="button" (click)="onCancel()" class="p-button-text basin-mr-6">
    Cancel
  </button>

  <button pButton type="submit" (click)="onSave()" [disabled]="!hasChanges || form.invalid" class="p-button-text">
    Save
  </button>
</div>